
import { BaseRouteService } from "core/services";

class PickTicketDetailRouteService extends BaseRouteService {
	constructor() {
		super("pick-ticket-details");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,pickTicketHeaderId}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	updateBackOrder(resource) {
		return super.update(`${this.base}/update-back-order/{id}`, resource);	
	}

	updateSendSeparatelyQty(resource) {
		return super.update(`${this.base}/update-send-separately-qty/{id}`, resource);	
	}
	
}

export default PickTicketDetailRouteService;